mutation deleteSessionsByHolidays(
  $scenarioId: ID!
  $originId: ID!
  $input: DeleteSessionsByHolidaysInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    sessionsByHoliday(input: $input) {
      commited
      link {
        id
        code
        sections {
          id
          code
        }
      }
    }
    __typename
  }
}
